<template>
  <div
    :class="{
      'meter-teaser': true,
      'meter-teaser--not-reachable': false,
    }"
  >
    <div class="meter-teaser__left">
      <img :src="imageUrl" class="meter-teaser__img" />
    </div>
    <div class="meter-teaser__icon-text">
      <span class="meter-teaser__label">{{ meter.name || 'Unbekannt' }}</span>
    </div>
  </div>
</template>

<script>
import { assetPath } from '@/util'
import { useColors } from '@/composables/useColors';
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'meter-teaser',
  props: {
    meter: {
      type: Object,
      required: true,
    },
    showClockWhenTimerIsActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { colorPrimary } = useColors();

    const primaryColor = colorPrimary;

    const targetUrl = computed(() => {
      return `meters/efriends/${props.meter.settings.inverterHost}`;
    });

    const imageUrl = computed(() => {
      const manufacturer = (props.meter.manufacturer || 'custom')
        .replace(/\s*\([^)]*\)/g, '')
        .toLowerCase()
        .replace(/\s+/g, '-');
      return assetPath(`device-types/${manufacturer}.png`);
    });

    function formatTemperature(value) {
      if (typeof value === 'number') {
        return `${value.toFixed(1)} °C`;
      }
      return '-';
    }

    const temperature = computed(() => {
      return formatTemperature(props.meter.temperature);
    });

    return {
      primaryColor,
      targetUrl,
      imageUrl,
      temperature,
    };
  },
});
</script>

<style lang="scss">
  .meter-teaser {
    transition: $transition-base;
    padding: 1rem 1rem 1rem 0;
    margin-bottom: 0.25rem;
    display: grid;
    grid-template-columns: 70px 1fr;
    width: 100%;

    @media (max-width: #{$bp-xs - 1px}) {
      grid-auto-rows: 1fr;
    }

    @media (min-width: $bp-xs) {
      grid-template-columns: 85px 1fr;
    }

    // &--not-reachable {
    //   .meter-teaser__img {
    //     opacity: 0.4;
    //   }
    // }

    &__left {
      margin-left: auto;
      margin-right: auto;
      display: flex;
      align-items: center;

      @media (min-width: $bp-xs) {
        grid-row-start: 1;
        // grid-row-end: 3;
      }
    }

    &__icon-text {
      display: flex;
      align-items: center;
    }

    &__right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-left: 0.5rem;
      flex-grow: 0;
      flex-shrink: 0;
      grid-column-start: 4;
      grid-column-end: 5;

      @media (min-width: $bp-xs) {
        align-items: flex-start;
      }

      @media (min-width: $bp-ssm) {
        margin-left: 1rem;
      }
    }

    &__current-consumption {
      display: none;
      grid-area: 2 / 3 / 4 / 4;
      margin-left: 0.5rem;
      margin-top: 0.5rem;
      font-weight: 900;
      grid-column-start: 4;
      grid-column-end: 5;

      @media (min-width: $bp-xs) {
        display: flex;
        justify-content: flex-end;
      }
    }

    &__current-temperature {
      display: none;
      margin-top: 0.5rem;
      grid-area: 2 / 2 / 4 / 3;
      justify-content: flex-end;
      grid-column-start: 3;
      grid-column-end: 4;

      &--right {
        grid-column-start: 4;
        grid-column-end: 5;
      }

      @media (min-width: $bp-xs) {
        display: flex;
      }
    }

    &__img {
      max-width: 100%;
      margin-right: 0.5rem;
      max-height: 40px;
    }

    &__label {
      font-size: $font-size-md;
    }

    &__title {
      margin: 0;
      line-height: $line-height-min;
      font-size: $font-size-md;
      hyphens: auto;

      @media (min-width: $bp-xs) {
        font-size: $font-size-md;
        line-height: $line-height-sm;
      }

      @media (min-width: $bp-md) {
        font-size: $font-size-lg;
      }
    }

    &__description {
      display: none;
      flex-basis: 100%;
      hyphens: auto;

      @media (min-width: $bp-ssm) {
        display: block;
      }
    }

    &__spinner {
      width: 2rem;

      .icon {
        animation: spin 1.8s linear 0s infinite;
      }
    }

    &__timer-icon {
      width: 2rem;
      display: flex;

      @media (min-width: $bp-sm) {
        margin-right: 0.75rem;
      }
    }
  }
</style>
